import { render, staticRenderFns } from "./BackupLogPage.vue?vue&type=template&id=50e5fb58&scoped=true&"
import script from "./BackupLogPage.vue?vue&type=script&lang=js&"
export * from "./BackupLogPage.vue?vue&type=script&lang=js&"
import style0 from "./BackupLogPage.vue?vue&type=style&index=0&id=50e5fb58&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e5fb58",
  null
  
)

export default component.exports